/**
 * 토글 칩(BaseChip) 공통 스타일 SSoT.
 * 필터 칩(활성 navy / 비활성 흰색 토글)의 base·상태 클래스를 단일 출처로 모은다
 * (fieldStyles.ts 와 동일 철학 — 여러 곳에 복붙 시 드리프트 방지).
 *
 * 값 출처: MaterialsPage 인라인 칩 클래스를 글자 단위 그대로 이관(회귀 방지).
 */

/** 칩 공통 골격(상태 무관) — radius·border·padding·타이포. */
export const CHIP_BASE_CLASS =
  'rounded-[7px] border px-[13px] py-[6px] text-[13px] font-semibold tracking-[-0.01em] transition-colors';

/** 활성(선택) 상태 — navy 채움. */
export const CHIP_ACTIVE_CLASS = 'border-brand bg-brand text-white';

/** 비활성 상태 — 흰색 + hover 시 blue 보더·navy 텍스트. */
export const CHIP_INACTIVE_CLASS =
  'border-line bg-white text-body hover:border-brand-muted hover:text-brand';
